function getSitePage(){

    let SITE_PAGE = document.querySelector("#jsSite").getAttribute("data-site-page");
    if (typeof SITE_PAGE === "undefined" || SITE_PAGE == "") {
        SITE_PAGE = 'story'; // Default value
    }

    return SITE_PAGE;
}

function getGaTag(){

    return document.querySelector("#jsSite").getAttribute("data-gaTag");
}

function getNoIc(){

    if (typeof window.NO_IC === 'undefined') {
        return false;
    }

    return window.NO_IC;
}

function getSiteName(){
    return document.querySelector("#jsSite").getAttribute("data-site");
}

function getSitesInfoList(){
    return [
        {
            name: 'politics',
            google_analytics_id: 'UA-31527-1',
            google_analytics4_id: 'G-PLW1TH538V',
            prebid_src: '//a.publir.com/platform/264.js',
            // prebid_src: '//www.realclearpolitics.com/asset/publr/264.js',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearPolitics',
            disqus_shortname: 'realclearpolitics',
            // facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/RealClearPolitics-27088225427/timeline/',
            // twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/RealClearNews',
            twitter_related: 'RealClearNews,rcpvideo,TomBevanRCP',
            global_site_url: window.location.protocol+'//www.realclearpolitics.com',
            // A.A. Change for distro to white 05/21/2020
            // site_color: '#DC0000',
            site_color: '#fff',
            site_heading_color: '#DC0000',
            FB_app_id: '1593718380910611',
            global_data_loc: 'rcp',
            // REVCONTENT -- SPONSORED CONTENT IDS
            revc_id: 'rcjsload_802e64',
            revc_w: '39765',
            revc_id_side: '', // we do not have code for politics
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '56045',
            // Newsletter Promo Pop-up Auto List Select
            auto_list_ids: 'a4db5f2336|51f930c5ce|8c65b915a9|d6a76c9ec3|9da46952f0|7d83b1601b',
            spot_production_id: 'sp_v0xu5oCZ',

            evolok_enabled: true,
            story_stream_related: true,
            gotchosen_id: 'GC_e4431c0a82261742f007d36f767de82097f19bc6',
            admiral_id: 'kheWDeYGeFPPn7sQ-PfpnFawLUdDWzyeHyG7KzHYdGNzzO_EGgYRxGbqTxWp63lYO7EQQhO99Vs_A',
            admiral_enabled: true,
            admiral_url_1 : "https://railwayreason.com/v2cgevh9N3T8eapu9Bq3LmUn_Amx90mHuGKM6Ao5Yjibc61aEGilINy0",
            admiral_url_2 : "https://railwayreason.com/v2wlcoJ0AZPNPP506liflnxoX9I2q-oQLym08RXKKl1J3QsqfVw3G9_EhWskktjFQKcyi7VKV",

            mgid_hp_id : '970897',
            mgid_hp_after_covid: '970904',
            mgid_hp_rc: '970898',

            mgid_polls_id: '977408',
            mgid_polls_rc: '970911',
            mgid_polls_carousel: '981991',

            mgid_article_rc_id : '970917',
            mgid_article_in_content_p12 : '970919',
            mgid_article_carousel: '977485',
            mgid_article_bf_comments: '976893',
            mgid_amp_article: '970922',

            mgid_video: '970342',
            mgid_video_rc: '977465',

            mgid_election_carousel : '970915',

            lockerdome_id: 8988720963702375,
			lockerdome_slot: "ld-8584-1267",
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com',
        },
        {
            name: 'science',
            google_analytics_id: 'UA-31527-30',
            google_analytics4_id: 'G-9RKYPPRHPC',
            prebid_src: '//a.publir.com/platform/369.js',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearScience',
            disqus_shortname: 'realclearscience',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realclearscience/',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/rcscience',

            twitter_related: 'rcscience',
            global_site_url: window.location.protocol+'//www.realclearscience.com',
            site_color: '#37414A',
            site_heading_color: '#37414A',
            FB_app_id: '815061235213552',
            global_data_loc: 'rcsc',

            //rev content
            revc_id: 'rcjsload_bbbfdc',
            revc_w: '44986',
            revc_id_side: 'rcjsload_1c39c0',
            revc_w_side: '44987',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: '267b89dc8a',

            spot_production_id: 'sp_8lO2c91e',

            evolok_enabled: true,
            story_stream_related: true,
            gotchosen_id: '', //GC_5fe7981788ab4d52787073ab4ba4da08736240ce
            admiral_id : 'temdm_2ZpTy9S13Z0BrBi-JKGtm5kMoz1_C2bS4471uYWtpIP-nzW7kCv5_PAfCnVFOVccUeoNwoQ',
            admiral_enabled: true,
            admiral_url_1: "https://railwayreason.com/v2qsg3AXFECKl1KZWF5x5M-wPnhFG81KwIEMKhk8FEo9vUepmzCjmNr0",
            admiral_url_2: "https://railwayreason.com/v2sqjxdVQfHTCgyGMUY3RE4Yv7YYNocLw8KV5yRzai22cuXpYghIK850VFBEUGBjTGDV1w29T",

            mgid_hp_carosell: '992065',
            mgid_hp_lc: '992064',
            mgid_hp_rc: '992060',
            mgid_article_carousel: '992068',
            mgid_article_rc_id: '992067',
            mgid_article_in_content_p12: '992069',
            mgid_article_bf_comments: '992071',
            mgid_video: '992075',
            mgid_video_rc: '992072',

            lockerdome_id: 9006236947623271,
			lockerdome_slot: "ld-5443-4769",
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
        {
            name: 'world',
            google_analytics_id: 'UA-31527-20',
            google_analytics4_id: 'G-H5PNYZERGY',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearWorld',
            disqus_shortname: 'realclearworld',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/RealClearWorld/',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/RealClearWorld',

            twitter_related: 'RealClearNews',
            global_site_url: window.location.protocol+'//www.realclearworld.com',
            site_color: '#0C124D',
            site_heading_color: '#0C124D',
            FB_app_id: '2093313384226659',
            global_data_loc: 'rcw',

            //rev content
            revc_id: 'rcjsload_ff92c1',
            revc_w: '44988',
            revc_id_side: 'rcjsload_33e8a5',
            revc_w_side: '44989',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: 'd519acabbf|9960d29f6a|1630639ffc',

            spot_production_id: 'sp_LQqoi1VA',

            evolok_enabled: true,
            story_stream_related: false,
            gotchosen_id: 'GC_26a00fabb18c91dc38b21cfd18c00f09f22bf991',
            admiral_id : 'rmxHjWev3FqAzk5j_n04matxVkmsq9iBfWV6LK1YcoCMa1CQi0QN7HyP8r723rYdvkdJd6-92Cljg',
            admiral_enabled : true,
            admiral_url_1 : "https://railwayreason.com/v2lxuP7ypkm_QNv3G4n9dsK5CpnRHq0t1nMxnGkZXI4i3odeafJ2sEIc",
            admiral_url_2 : "https://railwayreason.com/v2bed-MQN6S0xlPTZDwta5l_wbgJlKJE0uNs9kobGCYdq3TW8NsyXDrWYzr9WQaLOksUnInLe",

            mgid_hp_carosell: '991932',
            mgid_hp_lc : '991928',
            mgid_hp_rc: '991926',

            mgid_article_rc_id: '991940',
            mgid_article_carousel: '991941',
            mgid_article_in_content_p12: '991944',
            mgid_article_bf_comments: '991947', //Smart Scroll
            mgid_video_rc: '991949',
            mgid_video: '991958',

            lockerdome_id: 9006233357299047,
			lockerdome_slot: "ld-8350-5589",
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
        {
            name: 'health',
            google_analytics_id: 'UA-31527-45',
            google_analytics4_id: 'G-99PE1ZH4XZ',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearHealth',
            disqus_shortname: 'realclearhealth',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realclearhealth/',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/RealClearHealth',

            twitter_related: 'realclearhealth',
            global_site_url: window.location.protocol+'//www.realclearhealth.com',
            site_color: '#DBB706',
            site_heading_color: '#DBB706',
            FB_app_id: '1767191100208431',
            global_data_loc: 'rche',

            //rev content
            revc_id: 'rcjsload_114cfb',
            revc_w: '45008',
            revc_id_side: 'rcjsload_d59572',
            revc_w_side: '45009',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            //Newsletter Promo Pop-up Auto List Select
            auto_list_ids: 'b4baf6b587',

            spot_production_id: 'sp_C6rOxoF6',

            evolok_enabled: false,
            story_stream_related: true,
            gotchosen_id: 'GC_88287009d64ebb9e5c1323cbcfa8acd524684150',
            admiral_id: 'woubv-ItxJzaF_-GdmVY-AK3Lclvjrftq9IJ_UD1m_p2Eq5e-LLbOJQCESJBBc7rgEBzG4RkIc7cw',
            admiral_enabled: true,
            admiral_url_1: "https://railwayreason.com/v2quqZ8hdw8E6GLl_C16SwAxcfgm03A6e9xAj752CRYz54lUjsFrRxrA",
            admiral_url_2: "https://railwayreason.com/v2qpil-Rbvg1Wr-Smw5LS-PXBpjK5XShF3TqjZS7sI2cJitTt_YD0FTXlFjHL-hIvVQ7nbW3n",


            mgid_hp_rc: '991885',
            mgid_hp_id: '',
            mgid_hp_lc: '991887',
            mgid_hp_carosell: '991889',
            mgid_article_rc_id: '991895',
            mgid_article_carousel: '991903',
            mgid_article_in_content_p12: '991905',
            mgid_article_bf_comments: '991906',
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'

        },
        {
            name: 'investigations',
            google_analytics_id: 'UA-31527-50',
            google_analytics4_id: 'G-236E64831K',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearInvestigations',
            disqus_shortname: 'realclearinvestigations',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realclearinvestigations/',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/RCInvestigates',

            twitter_related: 'realclearinvestigations',
            global_site_url: window.location.protocol+'//www.realclearinvestigations.com',
            site_color: '#5d5d5d',
            site_heading_color: '#5d5d5d',
            FB_app_id: '1615740298756569',
            global_data_loc: 'rci',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: 'd042379c8d',

            spot_production_id: 'sp_fGGCea9F',

            evolok_enabled: false,
            story_stream_related: true,
            admiral_id : '', //We need one for investigations
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
        {
            name: 'defense',
            google_analytics_id: 'UA-31527-39',
            google_analytics4_id: 'G-TWM4RZTSYC',
            prebid_src: '//a.publir.com/platform/371.js',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearDefense',
            disqus_shortname: 'realcleardefense',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realcleardefense/',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/RCDefense',

            twitter_related: 'RCDefense',
            global_site_url: window.location.protocol+'//www.realcleardefense.com',
            site_color: '#485228',
            site_heading_color: '#485228',
            FB_app_id: '1640169792979601',
            global_data_loc: 'rcd',

            //rev content
            revc_id: 'rcjsload_bbbfdc',
            revc_w: '44986',
            revc_id_side: 'rcjsload_1c39c0',
            revc_w_side: '44987',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: '694f73a8dc',

            spot_production_id: 'sp_DzWAHE1J',

            evolok_enabled: true,
            story_stream_related: true,
            gotchosen_id: 'GC_2547344cf6e04e73ce1abfadff9da2186b8ebafb',
            admiral_id : 'bau8KpBCi8nIUG6LYT2ZdaFe6Igr0UjcXZY-ecbD_Lpngc7cL-SYNW-XD7o29HdRy1MMGUePR0xUg',
            admiral_enabled: true,
            admiral_url_1: "https://railwayreason.com/v2dhqkydcypfgk5lQGGq0GNO_4eBkERX72zPSlHawcanHIbpawecgI3Y",
            admiral_url_2: "https://railwayreason.com/v2kjtSnkrmq4NcQENZ6s55jZVb_8PAQcZBRnC_kbtYRZPy2KUuQdawbYw2ubSiA3obmHVR2hS",

            mgid_hp_carosell: '991975',
            mgid_hp_lc: '991971',
            mgid_hp_rc: '991969',
            mgid_article_carousel: '991982',
            mgid_article_in_content_p12: '991985', //impact
            mgid_article_bf_comments: '991986',
            mgid_article_rc_id: '991980',

            lockerdome_id: 9006234598813031,
			lockerdome_slot: "ld-6105-3936",
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
        {
            name: 'energy',
            google_analytics_id: 'UA-31527-32',
            google_analytics4_id: 'G-TX117980T8',
            prebid_src: '//a.publir.com/platform/462.js',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearEnergy',
            disqus_shortname: 'realclearenergy',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realclearenergy/',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/realclearenergy',

            twitter_related: 'realclearenergy',
            global_site_url: window.location.protocol+'//www.realclearenergy.org',
            site_color: '#70AB41',
            site_heading_color: '#70AB41',
            FB_app_id: '255745351486296',
            global_data_loc: 'rce',

            //rev content
            revc_id: 'rcjsload_bbbfdc',
            revc_w: '44986',
            revc_id_side: 'rcjsload_1c39c0',
            revc_w_side: '44987',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: '462961a8ae|7d83b1601b',

            spot_production_id: 'sp_yhuNbXOh',

            evolok_enabled: true,
            story_stream_related: true,
            gotchosen_id: 'GC_f92cf3e7212877dba6e1d6fb969addc15917131a',
            admiral_id : 'dvaPUwYLIWX6he1MyEZtFQaFGj9MDjdHQ8XEeq-oLmCR7IffR3aiHfawPYzrNzmghfxIk3v9AXw3Q',
            admiral_enabled: true,
            admiral_url_1: "https://railwayreason.com/v2xerQ1ypeCT9mTPQQbMkUnF1FE9zlvxFISj7gHIDuEMEeGgnk1egXag",
            admiral_url_2: "https://railwayreason.com/v2ynb4CjafF9fsViBI1jvkx_PwmJLdYVvlkFNFPO3SViwNZmJi8hTmcIBSIr4CBhZ9M7XYT-A",

            mgid_hp_rc: '991800',
            mgid_hp_lc: '991799',
            mgid_hp_id: '991804',
            mgid_hp_carosell: '991803',
            mgid_article_rc_id: '991805',
            mgid_article_carousel: '991811',
            mgid_article_in_content_p12: '991812',
            mgid_article_bf_comments: '991813',

            lockerdome_id: 9006235739663719,
			lockerdome_slot: "ld-4747-8305",
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'

        },
        {
            name: 'policy',
            google_analytics_id: 'UA-31527-37',
            google_analytics4_id: 'G-4RE28NLWGL',
            prebid_src: '//a.publir.com/platform/461.js',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearPolicy',
            disqus_shortname: 'realclearpolicy',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realclearpolicy',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/realclearpolicy',

            twitter_related: 'realclearpolicy',
            global_site_url: window.location.protocol+'//www.realclearpolicy.com',
            //site_color: '#37414A',
            site_color: '#65198e',
            site_heading_color: '#65198e',
            FB_app_id: '1815769415347224',
            global_data_loc: 'rcpc',

            //rev content
            revc_id: 'rcjsload_bbbfdc',
            revc_w: '44986',
            revc_id_side: 'rcjsload_1c39c0',
            revc_w_side: '44987',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: 'ebf02493b3|113ee1bc69',

            spot_production_id: 'sp_YRUF6DPr',

            evolok_enabled: true,
            story_stream_related: true,
            gotchosen_id: 'GC_e2ef102a0ff5f0d4f77141e685d917450278897d',
            admiral_id : 'gucGPwZxS7-7JNZATFAg6Z1FyqZxi9EhwIZIyz-Dnj9WYluAUlDdfo7MQXUDmLMqBcL0HtQDe92ag',
            admiral_enabled: true,
            admiral_url_1:"https://railwayreason.com/v2pwngyVkzRLt8DJbZnOu5w_D6_j9BimntF0SskeHCenl5kJueN5Pe-4",
            admiral_url_2: "https://railwayreason.com/v2xlh00a-LY_SsxBZK1mq-S-6DYiKRancB_8GOgj5XtX8iJOVF0l3JvV0knVn5p-u1eHJczLI",

            mgid_hp_carosell: '991834',
            mgid_hp_rc: '991833',
            mgid_article_rc_id: '991837',
            mgid_article_carousel: '991838',
            mgid_article_in_content_p12: '991839',
            mgid_article_bf_comments: '991841',

            lockerdome_id: 9006230907825511,
			lockerdome_slot: "ld-645-588",
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
        {
            name: 'religion',
            google_analytics_id: 'UA-31527-29',
            google_analytics4_id: 'G-68333N9JR7',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearReligion',
            disqus_shortname: 'realclearreligion',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realclearreligion',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/realclearrelig',

            twitter_related: 'realclearreligion',
            global_site_url: window.location.protocol+'//www.realclearreligion.org',
            site_color: '#81C0C8',
            site_heading_color: '#81C0C8',
            FB_app_id: '346345255724798',
            global_data_loc: 'rcr',

            //rev content
            revc_id: 'rcjsload_bbbfdc',
            revc_w: '44986',
            revc_id_side: 'rcjsload_1c39c0',
            revc_w_side: '44987',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: '7f0a4512a1',

            spot_production_id: 'sp_QKKE0vl2',

            evolok_enabled: true,
            story_stream_related: true,
            gotchosen_id: 'GC_4fd3da3e573b20bda65b0e8d498e0c6909be936b',
            admiral_id : 'hqqD5RfuLRn7OWQjbTcF-4DXxGUxGUpn_7VwNanhglTPZ2RTJt5nHhCMmgEEW5XcoLcv3FXmC073Q',
            admiral_enabled : true,
            admiral_url_1: "https://railwayreason.com/v2mozhkMDp1M_frp30UEIyIK6gAAjo6MhtzIpUdA_Hkjo5quxtAiaU5Q",
            admiral_url_2: "https://railwayreason.com/v2goylpMYvcXPde_W4KibvkVTH2iFmcjVkzJLmYp7zJ-Er7QAq1t0HTLBpQBWMCA4kTLMzh39",

            mgid_hp_id: '992026',
            mgid_hp_rc: '992025',
            mgid_hp_lc: '',
            mgid_article_rc_id: '992028',
            mgid_article_carousel: '992029',
            mgid_article_bf_comments: '992037',
            mgid_article_in_content_p12: '',

            lockerdome_id: 9006238054919527,
			lockerdome_slot: "ld-8524-5884",
        },
        {
            name: 'education',
            google_analytics_id: 'UA-47207322-1',
            //google_analytics4_id: 'G-68333N9JR7',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearEducation',
            disqus_shortname: 'realcleareducation',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realcleareducation',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/realcleared',

            twitter_related: 'realcleared',
            global_site_url: window.location.protocol+'//www.realcleareducation.com',
            site_color: '#8b0000',
            site_heading_color: '#8b0000',
            FB_app_id: '1734472916875035',
            global_data_loc: 'rced',

            //rev content
            revc_id: 'rcjsload_bbbfdc',
            revc_w: '44986',
            revc_id_side: 'rcjsload_1c39c0',
            revc_w_side: '44987',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: '8a051b373b',

            spot_production_id: 'sp_4wiiImwx',

            evolok_enabled: false,
            story_stream_related: true,
            gotchosen_id: 'GC_4d726c2f8be9384b8213df11ce85e79f05438901',
            admiral_id: 'gej5jYTzEOg_bxW2QsnizGhVQfz5aF81yvBGEW_lY7aXT7o1fPE0nL46NK1DgknvbYRJ0uOdcw9pek',
            admiral_enabled: true,
            admiral_url_1: "https://railwayreason.com/v2fldR9yFZFoR739O92FGejN4SPYdrVKDWIvk0VINu02hj37CwFMNcEFL",
            admiral_url_2: "https://railwayreason.com/v2lcjDNM7jySxyqyKhyCMkx-ujJbTlJbRHFuW7TbpPv-mWenijuO-Bh5dAw88DB4vwYVhN2snHA",

            mgid_hp_rc: '991868',
            mgid_hp_lc: '991871',
            mgid_hp_carosell: '991873',
            mgid_article_rc_id: '991879',
            mgid_article_in_content_p12: '991965', //impact
            mgid_article_bf_comments: '991966',
            mgid_article_carousel: '991881',
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
        {
            name: 'books',
            google_analytics_id: 'UA-31527-35',
            google_analytics4_id: 'G-GFXX3HWTB9',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearBooks',
            disqus_shortname: 'realclearbooks',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realclearbooks',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/realclearbooks',

            twitter_related: 'realclearbooks',
            global_site_url: window.location.protocol+'//www.realclearbooks.com',
            site_color: '#017ba8',
            site_heading_color: '#017ba8',
            FB_app_id: '336545073384960',
            global_data_loc: 'rcb',

            //rev content
            revc_id: 'rcjsload_bbbfdc',
            revc_w: '44986',
            revc_id_side: 'rcjsload_1c39c0',
            revc_w_side: '44987',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: 'ea772b1135',

            spot_production_id: 'sp_sJMa8VBM',

            evolok_enabled: true,
            story_stream_related: true,
            gotchosen_id: 'GC_08cbadf551e2af130ce5a70c29c788e3bbde01fe',
            admiral_id: 'edfWdEafIytNBbG_o4jkBxjAnh1qWKYLmmk0m3T3o4brV0kQDf26rOxDt5K9NghHou_BPKVV9hQqM4',
            admiral_enabled: true,
            admiral_url_1: "https://railwayreason.com/v2ofuADVym5Ps7hDm_oEBSy8DWib4JA8RYuSMpb01FTHf8VKhzGT-QeLx",
            admiral_url_2: "https://railwayreason.com/v2hubKLNHqVqPkLv9wsJGeGuwB47DEHd5zaS3CvLc3Nt--yvoami7KP_tmBNt-rdY208gDszgKA",

            mgid_hp_rc: '992002',
            mgid_hp_id: '992006',
            mgid_hp_lc: '',
            mgid_hp_carosell: '992004',
            mgid_article_rc_id: '992007',
            mgid_article_carousel: '992009',
            mgid_article_in_content_p12: '992011',
            mgid_article_bf_comments: '992012',
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
        {
            name: 'history',
            google_analytics_id: 'UA-31527-34',
            google_analytics4_id: 'G-PTB2HN0HHT',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearHistory',
            disqus_shortname: 'realclearhistory',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realclearhistory',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/realclearhistry',

            twitter_related: 'realclearhistry',
            global_site_url: window.location.protocol+'//www.realclearhistory.com',
            site_color: '#cc6600',
            site_heading_color: '#cc6600',
            FB_app_id: '377784295946894',
            global_data_loc: 'rchi',

            //rev content
            revc_id: 'rcjsload_bbbfdc',
            revc_w: '44986',
            revc_id_side: 'rcjsload_1c39c0',
            revc_w_side: '44987',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: 'fbced764bd', // Update with new list id

            spot_production_id: 'sp_0xpjnq0B', //SPOT Production

            evolok_enabled: true,
            story_stream_related: true,
            gotchosen_id: 'GC_e97f0ff112ae2aaa0aec5780e51c7e70e4cba1e2',
            admiral_id : 'ssr79JFuvbQxZYBmufynXnTYiHr1nceWcrR_dP5tFdONJ2nRjGTU_gMZCqc3SPmgjDttgy6gZezihg',
            admiral_enabled: true,
            admiral_url_1: "https://railwayreason.com/v2dmeFmUUON80WhCqrPd2Aj0C0TZZSsEltO9H40n7abtBOaVqdM4UMguZ",
            admiral_url_2: "https://railwayreason.com/v2rkpS-aG26dg2U2LQAravhx3EyC47FmAKam377-7_YCBPIZqJ2Kl5ajUupNnsVZlwwXRumGyRQ",


            mgid_hp_rc: '991968',
            mgid_hp_lc: '991972',
            mgid_hp_carosell: '991979',
            mgid_article_rc_id: '991983',
            mgid_article_carousel: '992027',
            mgid_article_in_content_p12: '992030',
            mgid_article_bf_comments: '992034',

            lockerdome_id: 9371487677427814,
			lockerdome_slot: "ld-1371-6729",
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
        {
            name: 'markets',
            google_analytics_id: 'UA-31527-19',
            google_analytics4_id: 'G-4X55KGZR7F',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearMarkets',
            disqus_shortname: 'realclearmarkets',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realclearmarkets',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/rc_markets',

            twitter_related: 'rc_markets',
            global_site_url: window.location.protocol+'//www.realclearmarkets.com',
            site_color: '#669933',
            site_heading_color: '#669933',
            FB_app_id: '1798801117051770',
            global_data_loc: 'rcm',

            //M.B. REMOVED 1.9.17
            //rev content
            //revc_id: 'rcjsload_bbbfdc',
            //revc_w: '44986',
            //revc_id_side: 'rcjsload_1c39c0',
            //revc_w_side: '44987',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: '1f71a1eaa2', // Update with new list id

            spot_production_id: 'sp_9W7bDUIH',

            evolok_enabled: true,
            story_stream_related: true,
            gotchosen_id: 'GC_b10b9282e82eb93c968d2888fbc0aa757483040c',
            admiral_id: 'jgrdUt_QJrysUdQxcjEwC0-XJPAeOkpsrtcwUMs_OVHXSowdxlbgUEcgy3fNJZKLAnRpDoN3vgwyg',
            ic_ads_close: [
                {
                    'body_class' : 'home',
                    'ads' : ['ic_970x250_1'],
                },
                {
                    'body_class' : 'article',
                    'ads' : ['ic_728x90_1'],
                }
            ],

            admiral_enabled: true,
            admiral_url_1: "https://railwayreason.com/v2wqhdSEm3PWcA1bNIbaHtdPQ5RhmZ2KxIlknAW-AB7jFpx24UVjjLzM",
            admiral_url_2: "https://railwayreason.com/v2oms424pJudKaREss-_pPpWWIxGgRY2_s0qAcodfrkmQfc5XP-HmQcR2VaOUk_bdAoeurcfq",
            lockerdome_id: 9006232250002791,
			lockerdome_slot: "ld-865-4641",
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
        {
            name: 'publicaffairs',
            google_analytics_id: 'UA-31527-53',
            google_analytics4_id: 'G-2NK0JMCMRW',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: true,
            lazy_ads: true,
            site_title: 'RealClearPublicAffairs',
            //facebook link for main icon in new header menu bar
            facebook_url: 'https://www.facebook.com/realclearpublicaffairs/',
            //twitter link for main icon in new header menu bar
            twitter_url: 'https://twitter.com/RealClearPublicAffairs',

            twitter_related: 'realclearpublicaffairs',
            global_site_url: window.location.protocol+'//www.realclearpublicaffairs.com',
            site_color: '#013220',
            site_heading_color: '#013220',
            FB_app_id: '',
            global_data_loc: 'rcpa',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',

            auto_list_ids: '',

            spot_production_id: 'sp_rIO3togj',

            evolok_enabled: false,
            story_stream_related: true,
            admiral_id: '',
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        }, 
        {
            name: 'foundation',
            google_analytics_id: 'UA-31527-55',
            google_analytics4_id: 'G-GQVV38G14C',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: true,
            lazy_ads: false,
            site_title: 'RealClearFoundation',
            disqus_shortname: 'realclearfoundation',
            //facebook link for main icon in new header menu bar
            facebook_url: '',
            //twitter link for main icon in new header menu bar
            twitter_url: '',

            twitter_related: 'realclearfoundation',
            global_site_url: window.location.protocol+'//www.realclearfoundation.org',
            site_color: '#5d5d5d',
            site_heading_color: '#5d5d5d',
            FB_app_id: '',
            global_data_loc: 'rcfo',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',
            auto_list_ids: '',
            spot_production_id: '',
            evolok_enabled: false,
            story_stream_related: false,
            admiral_id: '',
        },
        {
            name: 'wire',
            google_analytics_id: '251123535',
            google_analytics4_id: 'G-EM61SH56T4',
            prebid_src: '',
            prebid_src_lazy: '',
            disable_all_ads: true,
            lazy_ads: false,
            site_title: 'RealClearWire',
            disqus_shortname: 'realclearwire',
            //facebook link for main icon in new header menu bar
            facebook_url: '',
            //twitter link for main icon in new header menu bar
            twitter_url: '',

            twitter_related: 'realclearwire',
            global_site_url: window.location.protocol+'//www.realclearwire.com',
            site_color: '#fff',
            site_heading_color: '#DC0000',
            FB_app_id: '',
            global_data_loc: 'rcwr',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',
            auto_list_ids: '',
            spot_production_id: '',
            evolok_enabled: false,
            story_stream_related: false,
            admiral_id: '',
        },
        {
            name: 'pennsylvania',
            prebid_src: '',
            prebid_src_lazy: '',
            google_analytics4_id: 'G-XN9R6Z69TD',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearPennsylvania',
            //facebook link for main icon in new header menu bar
            facebook_url: '',
            //twitter link for main icon in new header menu bar
            twitter_url: '',
    
            twitter_related: 'realclearpennsylvania',
            global_site_url: window.location.protocol+'//www.realclearpennsylvania.com',
            site_color: '#002a86',
            site_heading_color: '#DC0000',
            FB_app_id: '',
            global_data_loc: 'rcpenn',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',
            auto_list_ids: '',
            spot_production_id: '',
            evolok_enabled: false,
            story_stream_related: false,
            admiral_id: '',
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
        {
            name: 'florida',
            prebid_src: '',
            google_analytics4_id: 'G-REWEG4GWZD',
            prebid_src_lazy: '',
            disable_all_ads: false,
            lazy_ads: true,
            site_title: 'RealClearFlorida',
            //facebook link for main icon in new header menu bar
            facebook_url: '',
            //twitter link for main icon in new header menu bar
            twitter_url: '',
    
            twitter_related: 'realclearflorida',
            global_site_url: window.location.protocol+'//www.realclearflorida.com',
            site_color: '#a80534',
            site_heading_color: '#DC0000',
            FB_app_id: '',
            global_data_loc: 'rcfl',
            // ZERG SPONSORED CONTENT SITE ID
            zerg_id: '',
            auto_list_ids: '',
            spot_production_id: '',
            evolok_enabled: false,
            story_stream_related: false,
            admiral_id: '',
            google_one_tap_client_id: '777032588331-0hh0seafv6nl1qima6eo3c8v07l4svjn.apps.googleusercontent.com'
        },
    ];
}

function getSiteInfo(site_name){

    site_name = site_name || getSiteName();
    let site_list = getSitesInfoList();

    let SITE_INFO = {};
    let SITE_INFO_INDEX = site_list.map((site) => { return site.name; }).indexOf(site_name);
    if( SITE_INFO_INDEX > -1 ){
        SITE_INFO = site_list[SITE_INFO_INDEX];
    }

    return SITE_INFO;
}

/**
 * expands the calculated visual viewport area in all directions, so that elements can be loaded before they become visible
 * Ge the lazy size expand value
 * @returns {int}
 */
function getLazyExpand(){

    let LAZY_EXPAND = 150;

    if (window.outerWidth < 768) {
        LAZY_EXPAND += 100;
    }

    return LAZY_EXPAND;
}

/**
 * Config lazysizes library to look at ads - needs to be before the lazy sizes script
 * @returns {object}
 */
function getLazySizesConfig(){
    let lazySizesConfig = window.lazySizesConfig || {};

    // instead of default 'lazyload'
    lazySizesConfig.lazyClass = 'RC-AD';

    // 1 - only load visible elements, 2 - loads "very near"
    lazySizesConfig.loadMode = 2; 

    // expands the calculated visual viewport area in all directions, so that elements can be loaded before they become visible
    lazySizesConfig.expand = getLazyExpand(); 

    // should delay loading of fixed ads until they appear
    lazySizesConfig.loadHidden = false; 

    // Do not initialize on load. Init manually when ready.
    lazySizesConfig.init = false; 

    return lazySizesConfig;
}

/**
 * Return all site configs
 * @returns {object}
 */
function getSiteConfigs(){

    var site_name = getSiteName();
    var SITE_INFO = getSiteInfo();

    return {
        SITE_INFO: SITE_INFO,
        SITE_PAGE: getSitePage(),
        SITE_NAME: getSiteName(), 
        siteName: site_name,
        global_site_title: SITE_INFO['site_title'],
        disqus_shortname: SITE_INFO['disqus_shortname'],
        twitter_related: SITE_INFO['twitter_related'],
        site_name: site_name.charAt(0).toUpperCase()+site_name.slice(1),
        GA_TAG: getGaTag(),
        NO_IC: getNoIc(),
        stream_tags: {},  // ?
        RC_welcome_interval: null, //TRACKING INVERVAL FOR welcome_ad
        RC_homepage_video_interval: null, // ?
    };
}

/**
 * Sets all site configs into the window global scope
 * @returns {void}
 */
function setGlobalSiteConfigs(){

    let configs = getSiteConfigs();

    for (const key in configs) {
        window[key] = configs[key];
    }
}

export { 
    getSiteConfigs, 
    setGlobalSiteConfigs, 
    getSitePage, 
    getGaTag, 
    getNoIc, 
    getSiteName, 
    getSitesInfoList, 
    getSiteInfo, 
    getLazyExpand, 
    getLazySizesConfig,
};